import React, {
  Component
} from 'react';
import { Button, Segment, Form, Dropdown, Popup , Icon, Checkbox, Grid, Image} from 'semantic-ui-react';
import _ from 'lodash';
import {getStaticText} from '../../core/lang';
import {getConst} from '../../core/consts';
import accounting from 'accounting';
import ReactPixel from 'react-facebook-pixel';
import ReactGA from 'react-ga';
import {applyCard} from '../../core/apiClient';
import { withRouter } from 'react-router-dom';


class GeneralForm extends Component {
  constructor() {
    super();
    this.state = {
      applyMessage: '',
      firstName: '',
      lastName: '',
      phoneNumber: '',
      emailId: '',
      salary: '',
      terms: false,
      selfEmployed:false,
      phoneNumberCode: '',
      openApplyResponsePopup: false,
      goodTimeToCall: '',
      nationality: '',
      errors: {
        firstName: '',
        lastName: '',
        phoneNumber: '',
        emailId: '',
        terms: '',
        salary: '',
        nationality: '',
        incomeType: '',
      },
      onFocus: '',
      openConfirmPopup: false,
    }
  }

  onFocusField = (name) => {
    this.setState({onFocus: name})
  }

  handleInputChange = (e, {value, name}) => {
    const {telephone} = getConst(this.props.activeLanguage);
    if(name === 'emailId'){
      value = value.trim();
    }
    if(name === 'firstName' || name === 'lastName'){
      value = value.toUpperCase();
    }
    if (name === 'phoneNumber') {
      if (telephone.test(value)) {
        this.setState({
          [name]: value
        })
      }
    } else {
      this.setState({
        [name]: value
      })
    }
  }

  handlePhoneNumberCode = (e, {value}) => {
    this.setState({phoneNumberCode: value})
  }

  handleFirstNameBlur = () => {
    let valid = false;
    const {info_required_msg, only_alphanumeric_msg} = getStaticText(this.props.activeLanguage);
    const {alphaNumSpaceRegex} = getConst(this.props.activeLanguage);
    if (!alphaNumSpaceRegex.test(this.state.firstName)) {
      this.createError('firstName', only_alphanumeric_msg)
    } else if (_.isEmpty(this.state.firstName)) {
      this.createError('firstName', info_required_msg);
    } else {
      this.createError('firstName', '');
      valid = true;
    }
    this.onFocusField('')
    return valid;
  }

  handleLastNameBlur = () => {
    let valid = false;
    const {info_required_msg, only_alphanumeric_msg} = getStaticText(this.props.activeLanguage);
    const {alphaNumSpaceRegex} = getConst(this.props.activeLanguage);
    if (!alphaNumSpaceRegex.test(this.state.lastName)) {
      this.createError('lastName', only_alphanumeric_msg)
    } else if (_.isEmpty(this.state.lastName)) {
      this.createError('lastName', info_required_msg);
    } else {
      this.createError('lastName', '');
      valid = true;
    }
    this.onFocusField('')
    return valid;
  }

  handleEmailIdBlur = () => {
    let email = this.state.emailId;
    let valid = false;
    const {email_id_required_msg, email_id_valid_msg} = getStaticText(this.props.activeLanguage);
    const {emailRegex} = getConst(this.props.activeLanguage);
    if (_.isEmpty(email)) {
      this.createError('emailId', email_id_required_msg);
    } else if (!emailRegex.test(email)) {
      this.createError('emailId', email_id_valid_msg);
    } else {
      this.createError('emailId', '');
      valid = true;
    }
    this.onFocusField('')
    return valid;
  }

  handlePhoneNumberBlur = () => {
    let valid = false;
    const {phone_number_valid_msg} = getStaticText(this.props.activeLanguage);
    if (_.isEmpty(this.state.phoneNumber) || this.state.phoneNumber.length !== 7 || this.state.phoneNumber.includes(' ')
        || _.isEmpty(this.state.phoneNumberCode)|| this.state.phoneNumberCode.length !== 3) {
      this.createError('phoneNumber', phone_number_valid_msg);
    } else {
      this.createError('phoneNumber', '');
      valid = true;
    }
    this.onFocusField('')
    return valid;
  }

  handleSalaryBlur = () => {
    let valid = false;
    const {please_input_salary,please_input_min_salary} = getStaticText(this.props.activeLanguage);
    if (this.state.salary < 1 || this.state.salary === undefined) {
      this.createError('salary', please_input_salary);
    }else if(this.state.salary < 0){
      this.createError('salary', please_input_min_salary);
    } else {
      this.createError('salary', '');
      valid = true
    }
    this.onFocusField('')
    return valid;
  }

  handleSalaryInputChange = (e, {value, max}) => {
    const formatedValue = accounting.unformat(value)
    let validValue = formatedValue;
    if (max < formatedValue) {
      validValue = max;
    }
    this.setState({ salary: _.toNumber(validValue) })
  }

  createError = (field, error) => {
    const errors = _.assign(this.state.errors, {[field]: error})
    this.setState({
      errors
    })
  }

  handleTerms = (e, {checked}) => {
    this.setState({terms: checked})
  }

  handleTermsValidate = () => {
    let valid = false;
    const {accept_terms_message} = getStaticText(this.props.activeLanguage);
    if (!this.state.terms) {
      this.createError('terms', accept_terms_message);
    } else {
      this.createError('terms', '');
      valid = true;
    }
    return valid;
  }

  finalCardApply = (utmSource,utmMedium,utmCampaign) => {
    if(utmCampaign===null){
      utmCampaign = 'Nil';
    }
    else{
      utmCampaign = sessionStorage.getItem("utm_campaign")
    }

    if(utmMedium===null){
      utmMedium = 'Nil';
    }
    else{
      utmMedium = sessionStorage.getItem("utm_medium")
    }

    if(utmSource===null){
      utmSource = 'Nil';
    }
    else{
      utmSource = sessionStorage.getItem("utm_source")
    }
    let referrer = document.referrer;
    if(referrer===''|| _.isEmpty(referrer)){
      referrer = window.location.href;
    }

    console.log("Referrer URL apply form:", referrer);

    const validFirstName = this.handleFirstNameBlur(), validLastName = this.handleLastNameBlur(),
      validEmail = this.handleEmailIdBlur(), validPhone = this.handlePhoneNumberBlur(),
      validTerms = this.handleTermsValidate(), salary = this.handleSalaryBlur();

    if (validFirstName && validLastName && validEmail && validPhone && validTerms && salary) {
        let email = this.state.emailId;
        let id =  this.props.data.applyId;
        id = parseInt(id, 10);
        if (_.isEmpty(email)) {
          email = this.props.simulateEmail;
        }

        applyCard({
          'customer': {
            'first_name': this.state.firstName,
            'email': email,
            'last_name': this.state.lastName,
            'phone': `+971${this.state.phoneNumberCode}${this.state.phoneNumber}`,
            'salary': this.state.salary,
            "utm_tracking_details": {
              "utm_source": utmSource,
              "utm_medium": utmMedium,
              "utm_campaign": utmCampaign,
              "request_url": window.location.href,
              "http_referrer": referrer
              }
          },
          'productIds': [id]
        }
        ).then((response) => {
          ReactPixel.fbq('track', 'SubmitApplication');
          this.props.history.push(`/thank-you-page/apply-credit-card/${id}`);
        }).catch((err) =>{
          const {multiple_apply_error} = getStaticText(this.props.activeLanguage);
          this.props.history.push(`/thank-you-page/apply-credit-card/${id}`);
        })
    }
  }

  render() {

    var hiddenFields = document.querySelectorAll("input[type=hidden], input[type=text]");

    for (var i=0; i<hiddenFields.length; i++) {
      var utmParam = sessionStorage.getItem(hiddenFields[i].name);
          var utmCampaign = sessionStorage.getItem("utm_campaign");

          var utmMedium = sessionStorage.getItem("utm_medium");

          var  utmSource = sessionStorage.getItem("utm_source");
          //document.getElementById("utm-source-hidden-field").value = 'hi';

          if (utmParam) {
            document.getElementsByName("utm_campaign")[0].value = utmCampaign;
            document.getElementsByName("utm_medium")[0].value = utmMedium;
            document.getElementsByName("utm_source")[0].value = utmSource;
          }
    }

    let referrer = document.referrer;
    if(referrer===''){
      referrer = window.location.href;
    }
    const lang = getStaticText(this.props.activeLanguage);
    const {phoneNumberCode} = getConst(this.props.activeLanguage);

    return (
      <Segment>
        <Grid className="ui" stackable>
          <Grid.Row className="general-container">
            <Grid.Column width={10}>
              <Image src='https://soulwallet.com/credit-cards/storage/app/media/cc_banner_img.svg' />
            </Grid.Column>
            <Grid.Column width={5} className='general-form-content segment'>
              <Form className='custom-form ' id='general-form'>
                <div className='form-control'>
                  <span className={!_.isEmpty(this.state.firstName) || this.state.onFocus === 'firstName'?'label-animate active': 'label-animate'}>{lang.first_name} <span className='asterik'>*</span></span>
                  <Form.Input
                    value={this.state.firstName}
                    onBlur={this.handleFirstNameBlur}
                    name='firstName'
                    onChange={this.handleInputChange}
                    maxLength={30}
                    id='general-first'
                    onFocus={(value) => this.onFocusField('firstName')}
                  />
                  <span className='input-error'>{this.state.errors.firstName}</span>
                </div>
                <div className='form-control'>
                  <span className={!_.isEmpty(this.state.lastName) || this.state.onFocus === 'lastName'?'label-animate active':'label-animate'}>{lang.last_name} <span className='asterik'>*</span></span>
                  <Form.Input
                    value={this.state.lastName}
                    onBlur={this.handleLastNameBlur}
                    name='lastName'
                    onChange={this.handleInputChange}
                    maxLength={30}
                    id='apply-last'
                    onFocus={(value) => this.onFocusField('lastName')}
                  />
                  <span className='input-error'>{this.state.errors.lastName}</span>
                </div>
                <div className='form-control'>
                  <span className={!_.isEmpty(this.state.emailId) || this.state.onFocus === 'emailId'?'label-animate active':'label-animate'}>{lang.email_id} <span className='asterik'>*</span></span>
                  <Form.Input
                    value={this.state.emailId}
                    onBlur={this.handleEmailIdBlur}
                    name='emailId'
                    onChange={this.handleInputChange}
                    maxLength={50}
                    id='apply-email'
                    onFocus={(value) => this.onFocusField('emailId')}
                  />
                  <span className='input-error'>{this.state.errors.emailId}</span>
                </div>
                <div className='form-control'>
                  <span className={!_.isEmpty(this.state.phoneNumber) || this.state.onFocus === 'phoneNumber'?'label-animate active top-0':'label-animate top-0'}><span className='asterik'></span></span>
                  <div className='phone-number-wrap'>
                    <span>+971</span>
                    <div className='label'>
                    <Dropdown
                        value={this.state.phoneNumberCode}
                        selection
                        options={phoneNumberCode}
                        onChange={this.handlePhoneNumberCode}
                        search={false}
                      />
                    </div>
                    <div className='field-phone-number'>
                    <Form.Input
                        value={this.state.phoneNumber}
                        placeholder={`${lang.ex}: 8989899`}
                        onBlur={this.handlePhoneNumberBlur}
                        name='phoneNumber'
                        type='tel'
                        pattern='[0-9]{7}'
                        onChange={this.handleInputChange}
                        maxLength={7}
                        id='apply-phone'
                        onFocus={(value) => this.onFocusField('phoneNumber')}
                        onKeyPress={this.digitValidate}
                      />
                    </div>
                  </div>
                  {
                    (this.state.phoneNumberCode==='' || this.state.phoneNumber==='' ||  _.size(this.state.phoneNumber)!==7)?
                    <span className='input-error'>{this.state.errors.phoneNumber}</span>:''
                  }
                </div>
                <br/>
                <div className='form-control'>
                  <span className={this.state.salary > 0 || this.state.onFocus === 'salary'?'label-animate active':'label-animate'}>Monthly Salary in AED<span className='asterik'>* </span></span>
                  <Form.Input
                    onChange={this.handleSalaryInputChange}
                    //value='abd'
                    pattern='[0-9]*'
                    value={this.state.salary>0? `${lang.aed} ${accounting.formatMoney(this.state.salary, '', 0)}`:''}
                    //placeholder='8989899'
                    max={200000}
                    type='tel'
                    onBlur={this.handleSalaryBlur}
                    onFocus={(value) => this.onFocusField('salary')}
                    className='has-price-format margin-btm-0'
                    onKeyPress={this.digitValidate}
                  />
                  <span className='input-error'>{this.state.errors.salary}</span>
                  <div className='min-salary-text'>Minimum salary AED {window.location.pathname.includes('home-loans')? '15,000' : '5,000'}*</div>
                </div>
                <div className='form-control padding-top-0 direct-apply--terms'>
                  <Form.Checkbox checked={this.state.terms} onClick={this.handleTerms} required label='' className='des-apply unasterik'></Form.Checkbox>
                    <label className='width-90 display-inline-block margin-left-10'>
                      {lang.apply_terms} I confirm that I have read and agree to Soulwallet Portal LLC’s <a href='/terms-and-conditions' target="_blank">Terms</a> and <a href='/privacy-policy' target="_blank"> Privacy Policy</a>.
                    </label>
                    {
                      this.state.terms===false?
                      <span className='input-error'>{this.state.errors.terms}</span>:''
                    }
                  </div>
                <input type="hidden" id="utm-source-hidden-field" name="utm_source" value={utmSource===null?'Nil':utmSource} />
                <input type="hidden" id="utm-medium-hidden-field" name="utm_medium" value={utmMedium===null?'Nil':utmMedium} />
                <input type="hidden" id="utm-campaign-hidden-field" name="utm_campaign" value={utmCampaign===null?'Nil':utmCampaign}/>
              </Form>
              <div className='quick__apply-now'>
                <Button className='show-for-desktop quick-view-apply-btn btn btn-blue' id='submit-application' onClick={()=>this.finalCardApply(utmSource,utmMedium,utmCampaign)}>{lang.cta}</Button>
              </div>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    );
  }
}

export default withRouter(GeneralForm);



// WEBPACK FOOTER //
// ./src/components/applyForm/generalForm.js